/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect } from 'react';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import moment from 'moment';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import * as St from './styles';
import { icons } from '~/assets';
import { currencyMask } from '~/utils/masks';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import Loading from '~/components/loading';

const SelectParcelsQuantity: React.FC<any> = ({
  data,
  dataFinancial,
  dataVencimento,
  idFinanciamento,
  qtdParcelasAPagar,
  dataCorte,
  searchFinancing,
  setDataParcelas,
}) => {
  const [parcelsQuantity, setParcelsQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dialogIsSuccess, setDialogIsSuccess] = useState(false);
  const [dialogIsFail, setDialogIsFail] = useState(false);
  const [parcelsData, setParcelsData] = useState<any>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [requestCalculation, setRequestCalculation] = useState(false);

  const RequestCreateAntecipation = useApi(
    Endpoints.invoices.postAntecipation,
    ApiMethod.POST,
  );

  const getCalculationParcels = useApi(
    Endpoints.invoices.getAntecipationCalculation
      .replace('PARAM_ID_FINANCIAMENTO', idFinanciamento)
      .replace('PARAM_QTD_PARCELAS', String(parcelsQuantity)),
    ApiMethod.GET,
  );

  const calculationParcels = async () => {
    setLoading(true);

    const response: any = await getCalculationParcels.callApi();

    if (response.status >= 200 && response.status < 300) {
      setParcelsData(response.data.data);
      setLoading(false);
    } else {
      setLoading(false);
      setDialogIsFail(true);
      setErrorMessage('Não foi possível calcular as parcelas!');
      setParcelsQuantity(0);
    }
  };

  useEffect(() => {
    if (requestCalculation) {
      calculationParcels();
      setParcelsData(parcelsData);
    }
  }, [parcelsQuantity, requestCalculation]);

  const handleParcelsQuantity = (operation: string) => {
    if (operation === '+') {
      setParcelsQuantity((prev) => prev + 1);
      setRequestCalculation(true);
    }
    if (operation === '-') {
      if (parcelsQuantity === 0) return;
      if (parcelsQuantity === 1) {
        const payload = {
          parcelasAAntecipar: 0,
          valorAntecipacao: 0,
          tipoAntecipacao: 'COMPRA',
          idCompra: data.idCompra,
          valorReal: data.valorReal,
          valorDesconto: data.valorDesconto,
        };

        setDataParcelas(payload);
        return;
      }
      setParcelsQuantity((prev) => prev - 1);
      setRequestCalculation(true);
    }
  };
  const modalIsOpen = () => {
    setModalOpen(true);
  };

  function handleClick() {
    const payload = {
      parcelasAAntecipar: parcelsData.parcelasAAntecipar,
      valorReal: parcelsData?.valorReal,
      valorDesconto: parcelsData?.valorDesconto,
      valorAntecipacao: parcelsData?.valorAntecipacao,
      tipoAntecipacao: 'FINANCIAMENTO',
      idFinanciamento: idFinanciamento,
    };

    setDataParcelas(payload);
  }

  const requestFinancialParcel = async () => {
    const payload = {
      cartao: data?.cartao,
      cpf: data?.cpf,
      dataFechamento: String(moment(dataCorte).format('YYYY-MM-DD')),
      dataVencimento: String(moment(dataVencimento).format('YYYY-MM-DD')),
      email: data?.email,
      idParcelamento: idFinanciamento,
      nomeCliente: data?.nomeCompleto,
      parcelasAntecipadas: parcelsData.parcelasAAntecipar,
      valorAntecipacao: parcelsData.valorAntecipacao,
      tipoAntecipacao: 'FINANCIAMENTO',
    };

    try {
      const response: any = await RequestCreateAntecipation.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        setModalOpen(false);
        setDialogIsSuccess(true);
      } else {
        setErrorMessage(response.data?.mensagem);
        setModalOpen(false);
        setDialogIsFail(true);
      }
    } catch (err) {
      setModalOpen(false);
      setDialogIsFail(true);
    }
  };

  return (
    <>
      <Loading status={loading || RequestCreateAntecipation.loading} />
      <ContainerFlex width={50} center style={{ minHeight: '180px' }}>
        <St.Title>Antecipar quantas parcelas?</St.Title>
        <ContainerFlex row horizontal center style={{ gap: '20px' }}>
          <St.ActionsButton
            onClick={() => handleParcelsQuantity('-')}
            type="button"
            disabled={parcelsQuantity === 0}
          >
            <AiOutlineMinus />
          </St.ActionsButton>
          <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
            {`${String(parcelsQuantity).padStart(2, '0')} de ${String(
              qtdParcelasAPagar,
            ).padStart(2, '0')}`}
          </span>
          <St.ActionsButton
            onClick={() => handleParcelsQuantity('+')}
            type="button"
            disabled={parcelsQuantity >= qtdParcelasAPagar}
          >
            <AiOutlinePlus />
          </St.ActionsButton>
        </ContainerFlex>
        <St.Value>
          Valor: R$
          {` ${currencyMask(parcelsData?.valorAntecipacao)}`}
        </St.Value>
        {parcelsData?.valorDesconto > 0 && (
          <St.Value style={{ fontWeight: 400, marginBottom: 10 }}>
            Desconto: R$
            {` ${currencyMask(parcelsData?.valorDesconto)}`}
          </St.Value>
        )}
        <ContainerFlex center horizontal style={{ gap: '20px' }} row>
          <St.ButtonMain
            onClick={() => {
              handleClick();
            }}
            fitContent
            type="button"
            disabled={parcelsQuantity === 0}
          >
            Solicitar Antecipação
          </St.ButtonMain>
        </ContainerFlex>
        <Dialog
          icon={icons.exclamation}
          open={modalOpen}
          title={
            <span style={{ color: 'red' }}> Detalhes da antecipação </span>
          }
          positiveLabel="SIM"
          positiveAction={requestFinancialParcel}
          negativeLabel="NÃO"
          negativeAction={() => setModalOpen(false)}
        >
          <St.TableHistory>
            <tr>
              <th>Valor antecipado (a pagar)</th>
              <th>Data Vencimento</th>
              <th>Valor do desconto</th>
              <th style={{ borderRight: '1px solid gray' }}>Antecipação</th>
            </tr>
            <tr>
              <td>{`R$ ${currencyMask(parcelsData?.valorAntecipacao)}`}</td>
              <td>{moment(data?.dataVencimento).format('DD/MM/YYYY')}</td>
              <td>{`R$ ${currencyMask(parcelsData?.valorDesconto)}`}</td>
              <td style={{ borderRight: '1px solid gray' }}>
                {parcelsData.parcelasAAntecipar === qtdParcelasAPagar
                  ? 'TOTAL'
                  : 'PARCIAL'}
              </td>
            </tr>
          </St.TableHistory>
          <St.DescriptionDialog>
            {`Comunique o cliente que o valor de R$ ${
              parcelsData?.valorAntecipacao
                ? parcelsData.valorAntecipacao
                : '0,00'
            } virá na próxima fatura
            que vence dia ${moment(data?.dataVencimento).format(
              'DD/MM/YYYY',
            )}. Deseja confirmar a antecipação?`}
          </St.DescriptionDialog>
        </Dialog>
        <Dialog
          icon={icons.confirmation}
          open={dialogIsSuccess}
          message="Solicitação enviada com sucesso!"
          positiveLabel="Entendi"
          positiveAction={() => {
            setDialogIsSuccess(false);
            searchFinancing();
          }}
        />
        <Dialog
          icon={icons.warning}
          open={dialogIsFail}
          message={errorMessage}
          positiveLabel="Entendi"
          positiveAction={() => {
            setDialogIsFail(false);
            searchFinancing();
          }}
        />
      </ContainerFlex>
    </>
  );
};

export default SelectParcelsQuantity;
